import {makeLxTranslations} from "@lxo-blocks/react";

const MFAPUSH_VIEW_TRANSLATION = makeLxTranslations({
    namespace: "mfaPushViewTranslations",
    translations: {
        MFAPUSH_HEADLINE: "Sehen Sie auf Ihrem <bold>{{device}}</bold> nach.",
        MFAPUSH_DESCRIPTION_1: "Wir haben Ihnen soeben eine Aufforderung an Ihr verbundenes Endgerät {{device}} gesendet.",
        MFAPUSH_DESCRIPTION_2: "Folgen Sie den dort beschriebenen Anweisungen und kehren Sie dann zu lexoffice zurück.",
    }
});

export {MFAPUSH_VIEW_TRANSLATION};
